import { LoaderFunctionArgs, redirect } from "react-router";

export default async function marketplaceResultProfileLoader(args: LoaderFunctionArgs) {
  const routeParams = args.params;
  if (!routeParams) return redirect("/marketplace");
  return routeParams;
}
